<template>
  <v-layout row wrap>
    <v-flex xs12>
      <v-data-table :headers="headers" :items="seriesList" hide-actions no-data-text="Данные отсутствуют">
        <template slot="items" slot-scope="{item, index}">
          <td v-html="item.name"></td>
          <td class="text-xs-center">
            <div :style="{height:'25px',width:'45px',background:item.color}"></div>
          </td>
          <td class="text-xs-center pa-0 ma-0">
            <v-btn color="secondary" class="red--text ma-0" icon flat @click="deleteLine(index)"><v-icon>mdi-delete</v-icon></v-btn>
          </td>
        </template>
      </v-data-table>
      <span class="dashed pointer pull-right my-2" @click="showPanel=!showPanel">{{showPanel?'Свернуть панель':'Добавить линию'}}</span>
    </v-flex>
    <v-flex xs12 v-show="showPanel" class="grey lighten-3 pa-2">
      <v-layout row wrap>
        <template v-for="(item, index) in line">
          <v-flex xs3 class="pr-1">
            <v-select v-model="item.type" :items="objTypes" label="Тип" hide-details>
              <v-btn slot="prepend" icon flat color="secondary" @click="deleteObject(index)" style="margin: -5px 0 0"><v-icon>mdi-delete</v-icon></v-btn>
            </v-select>
          </v-flex>
          <v-flex xs9 class="pl-2">
            <v-select multiple v-model="item.objects"
                      :items="objects"
                      label="Срез" item-text="name" item-value="object_id"
                      no-data-text="Нет доступных срезов"
                      hide-details return-object>
              <template v-slot:selection="{ item, index }">
                <span v-if="index!==0">-></span>
                <span>{{ item.name }}</span>
              </template>
              
              <v-btn v-if="line.length===index+1" slot="append-outer" icon flat color="secondary" class="ma-0" @click="addObject"><v-icon>mdi-plus</v-icon></v-btn>
            </v-select>
          </v-flex>
        </template>
        <v-flex xs12>
          <div class="my-2">
            <p class="pa-0 mt-1" style="float: left">Цвет линии: </p>
            <div :style="{position: 'relative', display:'inline-block', marginLeft:'10px', cursor: 'pointer' , width:'60px', height: '30px', background: color}" @click="showColors=!showColors">
            <swatches-picker v-show="showColors" v-model="colors" @input="setColor"></swatches-picker>
            </div>
          </div>
        </v-flex>
        <v-flex xs12>
          <v-btn color="secondary" class="ml-0" @click="saveLine">Добавить</v-btn>
        </v-flex>
      </v-layout>
    
    </v-flex>
  
  </v-layout>
</template>

<script>
  import { Swatches } from 'vue-color'
  
  export default {
    name : "OutputSettings",
  
    components:{
      'swatches-picker': Swatches,
    },
    
    props:{
      objects: {
        type: Array,
        required: false,
        default: () => []
      },
      value: {
        type: Array,
        required: false,
        default: () => []
      },
    },
  
    computed:{
      seriesList:{
        get(){ return this.value },
        set(v){ }
      }
    },
  
    data(){
      return {
        showPanel: false,
        headers: [
          { text: 'Срез', sortable: false },
          { text: 'Цвет', align: 'center', sortable: false, width: 100 },
          { text: 'Действия', align: 'center', sortable: false, width: 100 },
        ],
        objTypes: [
          { text:'Только выбранные', value:0 },
          { text:'Все вхождения', value:1 }
        ],
        showColors: false,
        colors: {
          hex: '#0288d1',
          hsl: {
            h: 201,
            s: 98,
            l: 41,
            a: 1
          },
          hsv: {
            h: 0.3470,
            s: 0.9853,
            v: 0.5333,
            a: 1
          },
          rgba: {
            r: 2,
            g: 136,
            b: 209,
            a: 1
          },
          a: 1
        },
        color: '#0288d1',
        line: [{type: 0, objects: []}],
      }
    },
    
    methods: {
      setColor(){
        this.showColors = false
        this.color = this.colors.hex
      },
      
      addObject(){
        this.line.push({ type: 0, color: '#0288d1', objects: [] })
      },
  
      deleteObject(index){
        this.$dmsAgree('Вы уверены, что хотите удалить объект из линии?').then( _ => {
          this.line.splice(index,1)
        })
      },
      
      saveLine(){
        let name = ''
        this.line.map( (item,index) => {
          let temp = ''
          if(item.type===1){
            temp = '<i aria-hidden="true" class="v-icon mdi mdi-sigma" style="font-size:20px"></i>('
          }
          item.objects.map( (obj, ind) => {
            obj.object_id = obj.id
            let sep = (ind===item.objects.length-1) ? '' : '->'
            temp= temp + obj.name + sep
          })
          if(item.type===1) temp+=')'
          if(index!==this.line.length-1){
            temp+='<i aria-hidden="true" class="v-icon mdi mdi-ampersand" style="font-size:17px"></i>'
          }
          name+=temp
        })
        
        this.seriesList.push({
          line: this.line,
          color: this.color,
          name: name
        })
        
        this.$emit('input', this.seriesList)
        this.clearForm()
      },
  
      deleteLine(index){
        this.$dmsAgree('Вы уверены, что хотите удалить линию?').then( _ => {
          this.seriesList.splice(index,1)
          this.$emit('input', this.seriesList)
        })
      },
  
      clearForm(){
        this.currentLine = null
        this.color = '#0288d1'
        this.line = [{type: 0, objects: []}]
      }
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/apps/analytics_old/components/Common/OutputSettings.vue